import { CreateConsultEligibility } from 'domain/usecases/eligibility/create-consult-eligibility'
import { EligibilityRepository } from 'repository/interfaces/eligibility-repository'

export class RemoteCreateConsultEligibility
  implements CreateConsultEligibility
{
  constructor(private readonly eligibilityRepository: EligibilityRepository) {}

  async create(
    params: CreateConsultEligibility.Params
  ): Promise<CreateConsultEligibility.Model> {
    return await this.eligibilityRepository.createConsultEligibility(params)
  }
}

export type RemoteEligibilityCheckModel = CreateConsultEligibility.Model
